// var swiper = new Swiper(".logo-swiper", {
//   slidesPerView: 3,
//   spaceBetween: 30,
// });

// document.addEventListener("DOMContentLoaded", function () {
//   if (window.innerWidth > 767) {
//     const columns = document.querySelectorAll(".logos-with-animation .section-content-wrapper .group-block-content");
  
//     const group135 = [columns[0], columns[2], columns[4]].filter(Boolean);
//     console.log({group135})
//     const group24 = [columns[1], columns[3]].filter(Boolean);
//     console.log({group24})
//     const tl = gsap.timeline({ repeat: -1 });
  
//     gsap.set(columns, { yPercent: -200 });
  
//     function slideWithBounce(targets, toYPercent, direction = "up", delay = 0) {
//       let bounceOffset = direction === "up" ? toYPercent - 5 : toYPercent + 5;
  
//       tl.to(targets, {
//         yPercent: bounceOffset,
//         duration: 0.5,
//         ease: "power2.out",
//         delay: delay,
//       });
//       tl.to(targets, {
//         yPercent: toYPercent,
//         duration: 0.2,
//         ease: "power1.out",
//       });
//     }
//     slideWithBounce(columns, 0, "down", 0.8);
  
//     slideWithBounce(group135, -100, "up", 0.8);
  
//     slideWithBounce(group24, -100, "up", 0.8);
  
//     slideWithBounce(group135, -200, "up", 0.8);
  
//     slideWithBounce(group24, -200, "up", 0.8);
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   // Custom mobile view animation trigger
//   if (window.innerWidth <= 767) {
//     const mobileCustomSections = document.querySelectorAll(".your-mobile-custom-class"); 
//     // ↑ Replace 'your-mobile-custom-class' with the class name you’ll enter in the custom field for mobile

//     mobileCustomSections.forEach(section => {
//       const columns = section.querySelectorAll(".section-content-wrapper .group-block-content");
//       if (!columns.length) return;

//       const slideHeightPercent = 100;
//       const bounceOffset = 3;
//       const staggerDelay = 40;
//       const stepDelay = 1500;

//       let currentIndex = 0;
//       let totalSlides = 0;

//       columns.forEach(column => {
//         const originalChildren = Array.from(column.children);
//         totalSlides = Math.max(totalSlides, originalChildren.length);

//         originalChildren.forEach(child => {
//           const clone = child.cloneNode(true);
//           column.appendChild(clone);
//         });
//       });

//       function slideColumnTo(column, index) {
//         return new Promise((resolve) => {
//           const y = -slideHeightPercent * index;
//           const bounceY = y - bounceOffset;

//           gsap.to(column, {
//             yPercent: bounceY,
//             duration: 0.4,
//             ease: "power2.out",
//             onComplete: () => {
//               gsap.to(column, {
//                 yPercent: y,
//                 duration: 0.2,
//                 ease: "power1.out",
//                 onComplete: resolve
//               });
//             }
//           });
//         });
//       }

//       async function slideStep(index) {
//         const promises = [];

//         for (let i = 0; i < columns.length; i++) {
//           const delay = i * staggerDelay;
//           promises.push(
//             new Promise((resolve) => {
//               setTimeout(() => {
//                 slideColumnTo(columns[i], index).then(resolve);
//               }, delay);
//             })
//           );
//         }

//         await Promise.all(promises);
//       }

//       async function loopSlides() {
//         while (true) {
//           currentIndex += 1;
//           await slideStep(currentIndex);
//           await new Promise(r => setTimeout(r, stepDelay));

//           if (currentIndex >= totalSlides) {
//             currentIndex = 0;
//             columns.forEach(column => {
//               gsap.set(column, { yPercent: 0 });
//             });
//           }
//         }
//       }

//       loopSlides();
//     });
//   }
// });

let currentMode = null; // "desktop" | "mobile"
let desktopTL = null;

function killAllGSAP() {
  gsap.globalTimeline.clear();
  gsap.killTweensOf("*");
}

function initDesktop() {
  if (desktopTL) desktopTL.kill();

  const columns = document.querySelectorAll(
    ".logos-with-animation .section-content-wrapper .group-block-content"
  );

  if (!columns.length) return;

  const group135 = [columns[0], columns[2], columns[4]].filter(Boolean);
  const group24 = [columns[1], columns[3]].filter(Boolean);

  desktopTL = gsap.timeline({ repeat: -1 });

  gsap.set(columns, { yPercent: -200 });

  function slideWithBounce(targets, toYPercent, delay = 0) {
    desktopTL.to(targets, {
      yPercent: toYPercent - 5,
      duration: 0.5,
      ease: "power2.out",
      delay
    });
    desktopTL.to(targets, {
      yPercent: toYPercent,
      duration: 0.2,
      ease: "power1.out"
    });
  }

  slideWithBounce(columns, 0, 0.8);
  slideWithBounce(group135, -100, 0.8);
  slideWithBounce(group24, -100, 0.8);
  slideWithBounce(group135, -200, 0.8);
  slideWithBounce(group24, -200, 0.8);
}

function initMobile() {
  const sections = document.querySelectorAll(".your-mobile-custom-class");
  if (!sections.length) return;

  sections.forEach(section => {
    const columns = section.querySelectorAll(
      ".section-content-wrapper .group-block-content"
    );

    if (!columns.length) return;

    let index = 0;
    let total = 0;

    columns.forEach(col => {
      const items = [...col.children];
      total = Math.max(total, items.length);
      items.forEach(i => col.appendChild(i.cloneNode(true)));
    });

    function slide() {
      index++;
      columns.forEach((col, i) => {
        gsap.to(col, {
          yPercent: -100 * index,
          duration: 0.4,
          delay: i * 0.04,
          ease: "power2.out"
        });
      });

      if (index >= total) {
        index = 0;
        columns.forEach(col => gsap.set(col, { yPercent: 0 }));
      }
    }

    setInterval(slide, 1800);
  });
}

function checkMode() {
  const newMode = window.innerWidth > 767 ? "desktop" : "mobile";

  if (newMode === currentMode) return;

  currentMode = newMode;
  killAllGSAP();

  if (newMode === "desktop") {
    initDesktop();
  } else {
    initMobile();
  }
}

document.addEventListener("DOMContentLoaded", checkMode);
window.addEventListener("resize", checkMode);

